import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ILead, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDate } from "../../shared/JVDate";
import { AddDevice } from "./AddDevice";
import { IOpenForm } from "./MyLead";
import { format } from "date-fns";



const schema = yup.object({
    status_ID: yup.number().required("Status is required").min(1, "Status is required"),
});

interface Iprops {
    singleData: ILead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    hasPermission: (pageName: string, featureName?: string) => boolean,
    reloadData: () => void,
    reload: boolean,

}
interface IAccessoryGroup {
    accessoriesID: number;
    accessoriesName: string;
    quantity: number;
    rate: number;
    totalAmount: number;
}
interface IPlanDrop extends IDropdown {
    plan_Cost?: number
}
interface ISubscriptionGroup {
    device_ID: number;
    plan_ID: number;
    base_Price: number;
    deal_Price: number;
    plan_Name: string;
}
export const StatusUpdateAcces = (props: Iprops) => {
    const [status, setStatus] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);
    const [plan, setPlan] = useState<IPlanDrop[]>();
    const [purposeOfConnection, setPurposeOfConnection] = useState<any[]>();
    const [accessoryGroups, setAccessoryGroups] = useState<IAccessoryGroup[]>([]);
    const [openLeadRequirementManager, setOpenLeadRequirementManager] = useState({ singleData: {}, open: false } as IOpenForm);
    const [subscriptionGroups, setSubscriptionGroups] = useState<ISubscriptionGroup[]>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILead>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const requirementDetails = watch("status_ID");
    const extraDeal = watch("isExtraDeal")
    const planName = watch("plan_ID");
    const noOfConnections = watch("no_Of_Connections") || 0;
    const planCost = plan?.find((item) => item.id === planName)?.plan_Cost || 0;
    const dealPrice = watch("deal_Price") || 0;
    setValue("base_Price", planCost);
    const totalprice = planCost * noOfConnections;
    const totalDealPrice = dealPrice * noOfConnections;
    const info = `Total Base Price: ${planCost} * ${noOfConnections}= ${totalprice}`
    const info1 = `Total Deal Price: ${dealPrice} * ${noOfConnections}= ${totalDealPrice}`

    useEffect(() => {
        loadStatus();
        loadPlan();
        loadPurposeOfConnection();
    }, []);

    useEffect(() => {
        loadAccessoryGroups();
        loadAttachDeviceGroups();
    }, [props.open]);

    useEffect(() => {
        console.log(props.singleData)
        if (props.singleData.id) props.singleData.contact = {
            id: props.singleData.contact_ID || 0,
            contact_Person_Name: props.singleData.contact_Person_Name + ' | ' + props.singleData.contact_Person_Number,
        };

        const updatedData = {
            ...props.singleData,
            isExtraDeal: props.singleData.isExtraDeal === 1,
            followup_Date: props.singleData.followup_Date ? new Date(props.singleData.followup_Date) : undefined,
        };
        reset(updatedData);

    }, [props.singleData]);


    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            setStatus(await response.json());
        }
    }

    const loadPlan = async () => {
        const response = await Fetch("subscription_Plan/dropdown", "GET", null, null, null);
        if (response) {
            setPlan(await response.json());
        }
    }

    const loadPurposeOfConnection = async () => {
        const response = await Fetch("PurposeOfConnection/dropdown", "GET", null, null, null);
        if (response) {
            setPurposeOfConnection(await response.json());
        }
    }

    const loadAttachDeviceGroups = async () => {
        const res = await Fetch(`Leads/getAttachDeviceById/${props.singleData.id}`, "GET", null, null, null);
        if (res) {
            const json = await res.json();
            setSubscriptionGroups(json.data);
        }
    }

    const saveToDB = async (body: ILead) => {
        setSubmitting(true);
        body.contact_ID = body.contact?.id;
        delete body.contact;
        if (body.followup_Date) {
            body.followup_Date = format(new Date(body.followup_Date), 'yyyy-MM-dd') as any;
        }
        const response = await Fetch(`leads/mylead${props.singleData.id ? '/' + props.singleData.id : ''}`, "PUT", body, null, props.toast);

        if (response) {
            let xyzData: any = await response.json();
            if (xyzData?.type == 1) {
                props.toast.current.show({ severity: 'error', detail: xyzData.message, life: 3000 });
                setSubmitting(false);
                setTimeout(() => {
                    setOpenLeadRequirementManager({ singleData: props.singleData, open: true });
                }, 2000);
            } else {
                onHide();
                props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
                props.reloadData();
            }
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: ILead) {
        if (data.status_ID == 4 && (data.no_Of_Connections == null || data.no_Of_Connections == undefined || data.no_Of_Connections == 0)) {
            props.toast.current.show({ severity: 'error', detail: "Please First Fill No. Of Connection", life: 3000 });
        }
        else if (data.status_ID == 3 && (data.no_Of_Connections == null || data.no_Of_Connections == undefined || data.no_Of_Connections == 0)) {
            props.toast.current.show({ severity: 'error', detail: "Please First No. Of Connection", life: 3000 });
        }
        else {
            saveToDB(data);
        }
    }

    const loadAccessoryGroups = async () => {
        const res = await Fetch(`Leads/getAttachAccessorGroupwise/${props.singleData.id}`, "GET", null, null, null);
        if (res) {
            const json = await res.json();
            setAccessoryGroups(json.data);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "isExtraDeal") {
                if (value.isExtraDeal === 1) {
                    setValue("isExtraDeal", 1);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header={`Update Lead Status (${props.singleData.contact_Person_Name} | ${props.singleData.contact_Person_Number})`} modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdown disabled={props.singleData.status_ID === 4} column={2} label="Status" control={control} options={status} optionLabel="status_Name" optionValue="id" name="status_ID" placeholder="Select Status" error={errors.status_ID?.message} />
                    {requirementDetails != 3 && requirementDetails != 4 && <JVInput column={2} label="Comment" control={control} name="comment" />}
                    {(requirementDetails === 4 && <>
                        {/* <JVDropdown column={2} label="Plan Type" control={control} options={plan} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Status" error={errors.plan_ID?.message} /> */}
                        <JVInput column={2} label="No. Of Connections" control={control} name="no_Of_Connections" type="number" />
                        {/* <JVInput column={2} disabled label="Base Price($)" control={control} name="base_Price" /> */}
                        {/* <JVInput column={2} label="Deal Price($)" control={control} name="deal_Price" /> */}
                        {/* <JVCheckbox className="mt-5"
                            column={2} label="Extra Perks" control={control} name="isExtraDeal" /> */}
                        {/* {extraDeal && <JVInput column={2} label="Extra No. Of Days" control={control} name="extraNoOfDays" />} */}
                    </>)}
                    {(requirementDetails === 3 && <>
                        <JVDropdown column={2} label="Purpose Of Connection" control={control} options={purposeOfConnection} optionLabel="purposeOfConection" optionValue="id" name="purposeOfConId" placeholder="Select Purpose Of Connection" />
                        {/* <JVDropdown column={2} label="Plan Type" control={control} options={plan} optionLabel="plan_Name" optionValue="id" name="plan_ID" placeholder="Select Status" error={errors.plan_ID?.message} /> */}
                        <JVInput column={2} label="No. Of Connection" control={control} name="no_Of_Connections" type="number" />
                        {/* <JVInput column={2} disabled label="Base Price($)" control={control} name="base_Price" /> */}
                        <JVDate column={2} label="Next Follow-Up Date" control={control} name="followup_Date" />
                        <JVInput column={2} label="Comment" control={control} name="comment" />
                    </>)}
                    {props.singleData.no_Of_Connections != null && <div className="col-12">
                        <h5>Subscription Details</h5>
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Plan Name</th>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Base Price($)</th>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Deal Price($)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subscriptionGroups.map(item => (
                                    <tr key={item.device_ID}>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.plan_Name}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.base_Price}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.deal_Price}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={2} style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>Grand Total $</td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>
                                        {subscriptionGroups.reduce((sum, item) => sum + (item.deal_Price || 0), 0)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>}
                    {props?.singleData?.accessoriesCount != 0 && <div className="col-12 mt-4">
                        <h5>Accessories Details</h5>
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Item</th>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Qty</th>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Rate($)</th>
                                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Total($)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {accessoryGroups.map(item => (
                                    <tr key={item.accessoriesID}>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.accessoriesName}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.quantity}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.rate}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.totalAmount}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan={3} style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>Grand Total($)</td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px', fontWeight: 'bold' }}>
                                        {accessoryGroups.reduce((sum, item) => sum + (item.totalAmount || 0), 0)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>}
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </Dialog>
            <AddDevice hasPermission={props.hasPermission} singleData={openLeadRequirementManager.singleData} open={openLeadRequirementManager.open} hideDialog={() => setOpenLeadRequirementManager({ singleData: {}, open: false })} toast={props.toast} reloadData={props.reloadData} />

        </>
    );
}